// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-title{cursor:pointer}.panel-body,.panel-title{font-size:small}", ""]);
// Exports
module.exports = exports;
